var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClubOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13H11.5V3H4.5C3.94772 3 3.5 3.44772 3.5 4V13ZM3.5 20C3.5 20.5523 3.94772 21 4.5 21H11.5V15H3.5V20ZM13.5 21H20.5C21.0523 21 21.5 20.5523 21.5 20V11H13.5V21ZM13.5 3V9H21.5V4C21.5 3.44772 21.0523 3 20.5 3H13.5Z",
    fill: "#FF7A00",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21V11H21.5V21H13.5ZM3.5 13V4C3.5 3.44772 3.94772 3 4.5 3H11.5V13H3.5ZM9.5 11V5H5.5V11H9.5ZM4.5 21C3.94772 21 3.5 20.5523 3.5 20V15H11.5V21H4.5ZM5.5 19H9.5V17H5.5V19ZM15.5 19H19.5V13H15.5V19ZM13.5 3H20.5C21.0523 3 21.5 3.44772 21.5 4V9H13.5V3ZM15.5 5V7H19.5V5H15.5Z",
    fill: "#FF7A00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClubOrange);
export default __webpack_public_path__ + "static/media/Icon_Club_Orange.7a0bb3bfa51e882e82dcbe4ba9bfcb2c.svg";
export { ForwardRef as ReactComponent };